import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // this is a utility function for demunging s3 urls -
  // they come in with everything escaped properly, but slashes as %2F which causes confusion.
  demungeS3Url(s3Url) {
    return s3Url.replaceAll("%2F", "/");
  }
}
